import PropTypes from 'prop-types';
import React from 'react';
import BaseToolTip from 'common/Workqueue/BaseToolTip';

export const EDIT_SA_DISABLED_TOOLTIP_CODES = {
  REQUEST_ALREADY_SUBMITTED: 'request_already_submitted',
  CASE_CLOSED: 'case_closed',
};

const TOOLTIP_TEXT_BY_CODE = {
  [EDIT_SA_DISABLED_TOOLTIP_CODES.REQUEST_ALREADY_SUBMITTED]:
    'A request to change this authorization has already been submitted.',
  [EDIT_SA_DISABLED_TOOLTIP_CODES.CASE_CLOSED]:
    'Authorizations cannot be edited when the case is closed.',
};

export default function EditSADisabledToolTip({
  children,
  disabled,
  position,
  textCode,
}) {
  return (
    <BaseToolTip
      condition={disabled}
      position={position}
      text={TOOLTIP_TEXT_BY_CODE[textCode]}
    >
      {children}
    </BaseToolTip>
  );
}

EditSADisabledToolTip.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool.isRequired,
  position: PropTypes.oneOf([
    'top',
    'top-start',
    'top-end',
    'right',
    'bottom',
    'bottom-start',
    'bottom-end',
    'left',
  ]),
  textCode: PropTypes.oneOf(Object.values(EDIT_SA_DISABLED_TOOLTIP_CODES)),
};

EditSADisabledToolTip.defaultProps = {
  position: undefined,
  textCode: undefined,
};
